import {
  CascoCommonPeriodEnum,
  InstallmentsEnum,
  PackageEnum
} from '@insurance/api/requests'
import { Period } from '@insurance/components'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const PeriodInsurance = () => {
  const { t } = useTranslation()
  const { periodProps, installmentsProps, insurancePackageProps } = formProps(t)
  const { isEditable } = useCascoInsuranceValues()
  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  if (insurancePackage === PackageEnum.MINI) return null

  const periodOptions = Object.values(CascoCommonPeriodEnum)
    .filter((value) => typeof value === 'number')
    .sort((a, b) => b - a)
    .map((value) => ({
      label: t(`m${value}`),
      value
    }))

  const installmentsOptions = Object.values(InstallmentsEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      label: t(`installment_${value}`),
      value: value as number
    }))

  return (
    <Period
      periodProps={periodProps}
      installmentsProps={installmentsProps}
      periodOptions={periodOptions}
      installmentsOptions={installmentsOptions}
      periodDisabled={isEditable}
      installmentsDisabled={
        isEditable || insurancePackage === PackageEnum.FIFTY_FIFTY
      }
    />
  )
}
